import React, { Component } from "react";

class PasswordShowHide extends Component {
  constructor(props) {
    super();
    this.state = {
      hidden: true,
      password: ""
    };

    this.toggleShow = this.toggleShow.bind(this);
  }

  toggleShow() {
    this.setState({ hidden: !this.state.hidden });
  }

  componentDidMount() {
    if (this.props.password) {
      this.setState({ password: this.props.password });
    }
  }
  componentDidUpdate(prevProps,prevState){
    if (prevProps.password!==this.props.password) {
        this.setState({ password: this.props.password });
      }
  }
  render() {
    return (
      <div style={{paddingLeft:20}}>
        Your private_token:
        <input
          type={this.state.hidden ? "password" : "text"}
          style={{width:300,marginLeft:10,marginRight:10}}
          value={this.state.password}
          disabled
        />
        <button className="btn btn-warning" onClick={this.toggleShow}>Show / Hide</button>
      </div>
    );
  }
}

export default PasswordShowHide;


// WEBPACK FOOTER //
// ./src/components/PasswordShowHide.js